export default __webpack_public_path__ + "static/media/inex.cb083f55.png";